import { Injectable } from '@angular/core';
import { convertToSapDate, IAdapter } from 'src/app/lego-utils';
import { fallbackDate, fallbackString } from 'src/app/helpers/type-helpers';
import { Task, TaskStatus } from 'src/app/models/domain';
import { ITaskPatchModel } from 'src/app/models/domain/task-patch.model';
import { IMetadata, TaskStatusUpdateValue } from 'src/app/models/sap';
import { YPMPROJECTSRVTask } from 'src/generated-clients/project';

@Injectable({
  providedIn: 'root',
})
export class TaskAdapter implements IAdapter<Task, ITaskPatchModel> {
  public adaptToDTO(item: Partial<Task>): ITaskPatchModel {
    return {
      actualFinishDate: convertToSapDate(item.actualFinishDate),
      fixedFinishDate: convertToSapDate(item.fixedFinishDate),
      forecastedFinish: convertToSapDate(item.forecastedFinish),
      status: this.convertToTaskStatusUpdateValue(item.status),
    };
  }

  public adaptToDomain(item: IMetadata & YPMPROJECTSRVTask): Task {
    return new Task(
      `${fallbackString(item.projectGuid)};${fallbackString(item.taskGuid)}`,
      fallbackString(item.sortNumber),
      fallbackString(item.process),
      fallbackString(item.processText),
      fallbackString(item.projectGuid),
      fallbackString(item.taskGuid),
      fallbackString(item.taskLevel),
      fallbackString(item.objectType),
      fallbackString(item.explanation),
      item.status as TaskStatus,
      fallbackString(item.fixedStartConstraintType),
      fallbackString(item.fixedStartConstraintText),
      fallbackDate(item.fixedStartDate),
      fallbackString(item.fixedFinishConstraintType),
      fallbackString(item.fixedFinishConstraintText),
      fallbackDate(item.fixedFinishDate),
      fallbackDate(item.calculatedEarlyStartDate),
      fallbackDate(item.calculatedEarlyFinishDate),
      fallbackDate(item.calculatedLateStartDate),
      fallbackDate(item.calculatedLateFinishDate),
      fallbackDate(item.actualStartDate),
      fallbackDate(item.actualFinishDate),
      fallbackDate(item.forecastedStart),
      fallbackDate(item.forecastedFinish),
      item.__metadata
    );
  }

  private convertToTaskStatusUpdateValue(status?: TaskStatus): string | undefined {
    if (!status) {
      return undefined;
    }

    switch (status) {
      case TaskStatus.Released:
        return TaskStatusUpdateValue.Release;
      case TaskStatus.Completed:
        return TaskStatusUpdateValue.Complete;
      case TaskStatus.Canceled:
        return TaskStatusUpdateValue.ResetComplete;
      default:
        throw new Error(`Unsupported TaskStatus: "${status}"`);
    }
  }
}
